__turbopack_context__.v({
  "popover": "TemperaturaInfoPopover-module___xe6SG__popover",
  "temperatura-popover-enter": "TemperaturaInfoPopover-module___xe6SG__temperatura-popover-enter",
  "temperatura-popover-exit": "TemperaturaInfoPopover-module___xe6SG__temperatura-popover-exit",
});
